import type {
  ContentTrackingLinkFilter,
  ContentTrackingListParams,
  ContentTrackingPlatformFilter,
  ContentTrackingStageFilter,
} from '@/marketing/models/contentTracking';

export interface ContentTrackingFilterState {
  stage: ContentTrackingStageFilter | 'all';
  platform: ContentTrackingPlatformFilter | 'all';
  contentLink: ContentTrackingLinkFilter | 'any';
  sparkMissing: boolean;
  topVideoOnly: boolean;
  search: string;
}

export const DEFAULT_CONTENT_TRACKING_FILTERS: ContentTrackingFilterState = {
  stage: 'all',
  platform: 'all',
  contentLink: 'any',
  sparkMissing: false,
  topVideoOnly: false,
  search: '',
};

// An "@" in the search box is a handle; an email goes to the exact-email filter the server supports.
export function toListParams(filters: ContentTrackingFilterState): ContentTrackingListParams {
  const term = filters.search.trim();
  const isEmail = term.includes('@') && !term.startsWith('@');
  return {
    ...(filters.stage !== 'all' ? { stage: filters.stage } : {}),
    ...(filters.platform !== 'all' ? { platform: filters.platform } : {}),
    ...(filters.contentLink !== 'any' ? { contentLink: filters.contentLink } : {}),
    ...(filters.sparkMissing ? { sparkCode: 'missing' as const } : {}),
    ...(filters.topVideoOnly ? { topVideo: 'hasTopVideo' as const } : {}),
    ...(term && isEmail ? { email: term } : {}),
    ...(term && !isEmail ? { search: term.replace(/^@/, '') } : {}),
  };
}
